import { render, staticRenderFns } from "./SectorEditAll.vue?vue&type=template&id=7cf67ed3&scoped=true"
import script from "./SectorEditAll.vue?vue&type=script&lang=js"
export * from "./SectorEditAll.vue?vue&type=script&lang=js"
import style0 from "./SectorEditAll.vue?vue&type=style&index=0&id=7cf67ed3&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf67ed3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7cf67ed3')) {
      api.createRecord('7cf67ed3', component.options)
    } else {
      api.reload('7cf67ed3', component.options)
    }
    module.hot.accept("./SectorEditAll.vue?vue&type=template&id=7cf67ed3&scoped=true", function () {
      api.rerender('7cf67ed3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Sector/SectorEditAll.vue"
export default component.exports